var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandlers = function SvgHandlers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 111 121"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    clipPath: "url(#handlers_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2 30.5h107M2 60.5h107M2 90.5h107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 30.5,
    r: 11.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 60.5,
    r: 11.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 90.5,
    r: 11.5,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "handlers_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h110v120H.5z"
  })))));
};
export default SvgHandlers;